function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["characterLimit", "value", "invalid", "helpText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import { Button, createForm, Dialog, Flex, ProgressIndicator, Select, SrOnly, Text, Textarea, useId, useToasts } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { ApplicationActionName, CancelWithdrawActionName, TargetApplicationStageName } from "../../../../types";
import { useApplication, useApplicationStageChangeReasons, useSendApplicationAction } from "../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
export function CancelWithdrawActionDialog(_ref) {
  var actionId = _ref.actionId,
    onClose = _ref.onClose,
    _onSuccess = _ref.onSuccess;
  var _useTranslation = useTranslation('ManageApplicationButton'),
    t = _useTranslation.t;
  var toasts = useToasts();
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var parsedAction = CancelWithdrawActionName.safeParse(actionId).data;
  var _useApplicationStageC = useApplicationStageChangeReasons({
      enabled: !!parsedAction
    }),
    applicationStageChangeReasons = _useApplicationStageC.applicationStageChangeReasons,
    applicationStageChangeReasonsStatus = _useApplicationStageC.applicationStageChangeReasonsStatus;
  var _useSendApplicationAc = useSendApplicationAction(),
    sendApplicationAction = _useSendApplicationAc.sendApplicationAction,
    sendApplicationStatus = _useSendApplicationAc.sendApplicationStatus;
  var displayedReasons = applicationStageChangeReasons.filter(function (reason) {
    return reason.targetApplicationStage === TargetApplicationStageName.CANCELLATION;
  });
  var otherReason = displayedReasons.find(function (reason) {
    return reason.key === 'cancellation_other';
  });
  if (!parsedAction) {
    return null;
  }
  var isCancelAction = parsedAction === ApplicationActionName.CANCEL || parsedAction === ApplicationActionName.EDIT_CANCEL_REASON;
  return _jsxs(Dialog, {
    open: !!actionId,
    onOpenChange: function onOpenChange(newOpen) {
      return newOpen || onClose();
    },
    children: [_jsx(Dialog.Heading, {
      children: t("cancelWithdrawDialog.title.".concat(parsedAction))
    }), _jsxs(Dialog.Content, {
      children: [applicationStageChangeReasonsStatus === 'loading' && _jsx(Flex, {
        justify: "center",
        children: _jsx(ProgressIndicator, {
          variant: "circular",
          size: "lg",
          indeterminate: true,
          label: t('cancelWithdrawDialog.loading')
        })
      }), applicationStageChangeReasonsStatus === 'success' && _jsx(Form, {
        id: "cancelWithdrawForm",
        defaultValues: {
          reason: application.cancellationReasonKey || '',
          reasonAdditionalNote: application.cancellationReasonNote || ''
        },
        onSubmit: function onSubmit(values) {
          var request = isCancelAction ? {
            actionId: parsedAction,
            actionData: {
              cancellationReasonKey: values.reason,
              cancellationReasonAdditionalNote: values.reasonAdditionalNote
            }
          } : {
            actionId: parsedAction,
            actionData: {
              withdrawalReasonKey: values.reason,
              withdrawalReasonAdditionalNote: values.reasonAdditionalNote
            }
          };
          sendApplicationAction(request, {
            onSuccess: function onSuccess() {
              toasts.positive(t("cancelWithdrawDialog.success.".concat(parsedAction)));
              _onSuccess();
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              }
            }
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [_jsx(Field, {
            as: Select,
            name: "reason",
            label: t("cancelWithdrawDialog.reasonSelect.".concat(parsedAction)),
            appearance: "styled",
            required: t('requiredField'),
            enforceNoMissingOption: true,
            children: displayedReasons.map(function (reason) {
              return _jsx(Select.Option, {
                label: reason.label,
                value: reason.key
              }, reason.key);
            })
          }), _jsx(Field, {
            label: t('cancelWithdrawDialog.additionalComments'),
            name: "reasonAdditionalNote",
            as: TextAreaWithCharacterLimit,
            validate: function validate(value, _ref2) {
              var values = _ref2.values;
              if (values.reason === (otherReason === null || otherReason === void 0 ? void 0 : otherReason.key) && !value) {
                return t('cancelWithdrawDialog.otherAdditionalCommentsRequired', {
                  otherLabel: otherReason === null || otherReason === void 0 ? void 0 : otherReason.label
                });
              }
              return true;
            }
          })]
        })
      })]
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('cancelWithdrawDialog.cancelButton')
      }), _jsx(Button, {
        type: "submit",
        form: "cancelWithdrawForm",
        intent: "primary",
        emphasis: "contained",
        width: "fill",
        loading: sendApplicationStatus === 'loading',
        children: t("cancelWithdrawDialog.confirmButton.".concat(parsedAction))
      })]
    })]
  });
}
function TextAreaWithCharacterLimit(_ref3) {
  var _ref3$characterLimit = _ref3.characterLimit,
    characterLimit = _ref3$characterLimit === void 0 ? 500 : _ref3$characterLimit,
    value = _ref3.value,
    invalid = _ref3.invalid,
    helpText = _ref3.helpText,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  var _useTranslation2 = useTranslation('ManageApplicationButton'),
    t = _useTranslation2.t;
  var characterCountId = useId();
  var characterLimitExceeded = value.length > characterLimit;
  return _jsxs(Flex, {
    direction: "column",
    children: [_jsx(Textarea, _objectSpread(_objectSpread({}, otherProps), {}, {
      value: value,
      "aria-describedby": characterCountId,
      invalid: invalid || characterLimitExceeded,
      helpText: characterLimitExceeded ? t('characterCountError') : helpText
    })), _jsxs(Text, {
      variant: "bodyS",
      intent: characterLimitExceeded ? 'negative' : 'secondary',
      contrast: "mid",
      align: "end",
      id: characterCountId,
      children: [_jsx(SrOnly, {
        children: t('characterCount')
      }), value.length, "/", characterLimit]
    })]
  });
}